import { type AnalyticsPlugin } from 'analytics';

import { type AnalyticsEvent } from '@automation-suite/shared-clients-analytics-dispatcher';

export const consolePlugin: AnalyticsPlugin = {
  name: 'console',
  track: (event: AnalyticsEvent) => {
    event.payload.properties.MetaData.DispatchedBy = 'SIN-ConsolePlugin';
    console.log(event.payload.properties);
  },
};
